/* eslint-disable */
import {defineNuxtPlugin} from "nuxt/app";

export default defineNuxtPlugin((app) => {
  console.log('SETUP AR_GA')
  /*
  ** Only run on client-side and only in production mode
  */
  const config = useRuntimeConfig();
  if (config.public.NODE_ENV !== 'production') return
  /*
  ** Include Google Analytics Script
  */
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-WFXDHRS');

  if (!app?.vueApp?.router) {
    return;
  }

  /*
  ** Every time the route changes (fired on initialization too)
  */
  app.vueApp.router.afterEach((to, from) => {
    /*
    ** We tell Google Analytics to add a `pageview`
    */
    if (window.dataLayer) {
      console.log('dataLayer detected, pushing route change: %s, title %s', to.path, to.params.step)
      dataLayer.push({
        event: 'pageview',
        page: {
          path: to.path,
          title: to.params.step
        }
      });
    }
  })
})